import Dashboard from './../components/email-groups/Dashboard.vue'
import Show from './../components/email-groups/Show.vue'
import Create from './../components/email-groups/Create.vue'
import Edit from './../components/email-groups/Edit.vue'
import Root from './../components/Root.vue'
export default {
  path: 'email-groups',
  component: Root,
  children: [
    {
      path: '',
      name: 'admin.email-groups.dashboard',
      component: Dashboard
    },
    {
      path: ':id/show',
      name: 'admin.email-groups.show',
      component: Show
    },
    {
      path: 'create',
      name: 'admin.email-groups.create',
      component: Create
    },
    {
      path: ':id/update',
      name: 'admin.email-groups.edit',
      component: Edit
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/emailGroups.js